/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivitySearchIdsInternalRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {ActivitySearchIdsInternalResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const activitySearchIdsInternal = (request:ActivitySearchIdsInternalRequest, options?: CashRequestOptions) => post<ActivitySearchIdsInternalRequest, ActivitySearchIdsInternalResponse>("/2.0/cash/activity-search-ids-internal", request, {...options, rejectOnError: true })